import { Outlet, createFileRoute } from "@tanstack/react-router";

import { VStack } from "@/components/Layout";

import { DraftCatalogHeader } from "./_layout/-components";

export const Route = createFileRoute(
  "/_staff/device-catalog/draft/$id/_layout",
)({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <VStack className="gap-0">
      <DraftCatalogHeader />
      <Outlet />
    </VStack>
  );
}
